import React from 'react';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import { Textarea } from '@/Components/ui/textarea';
import { cn } from '@/lib/utils';

function CompanyForm({
  companyName, 
  setCompanyName, 
  companyLink, 
  setCompanyLink,
  aboutUs, 
  setAboutUs,
}) {
  return (
    <form className="flex flex-col gap-3.5 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
        <div className="flex flex-col gap-2">
          <Label htmlFor="company-name" className="text-sm font-semibold">
            Company name
          </Label>
          <Input 
            id="company-name"
            type="text" 
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="e.g., Acme Corporation"
            className="h-10"
          />
        </div>
        
        <div className="flex flex-col gap-2">
          <Label htmlFor="company-link" className="text-sm font-semibold">
            Company Link
          </Label>
          <Input 
            id="company-link"
            type="text"
            value={companyLink}
            onChange={(e) => setCompanyLink(e.target.value)}
            placeholder="e.g., acme-corporation"
            className="h-10"
          />
        </div>
      </div>
      
      <div className="flex flex-col gap-2">
        <Label htmlFor="about-us" className="text-sm font-semibold">
          About Us
        </Label>
        <Textarea 
          id="about-us"
          value={aboutUs}
          onChange={(e) => setAboutUs(e.target.value)}
          placeholder="Tell us about your company..."
          className="min-h-[84px] resize-none"
        />
      </div>
    </form>
  );
}

export default CompanyForm;